import request from '@/utils/request'

// 俱乐部-统计
export const clubStatistics = () => {
    return request.get(`/club/statistics`)
}

// 约骑-统计
export const personalCyclingStatistics = () => {
    return request.get(`/personalCycling/statistics`)
}

// 平台-用户统计
export const userStatistics = () => {
    return request.get(`/user/statistics`)
}

// 驿站-统计
export const storeStatistics = () => {
    return request.get(`/store/statistics`)
}
